import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Slider, Typography } from '@material-ui/core';
import Cropper from 'react-easy-crop';

const OUTPUT_SIZE = 512;

const loadImage = (src) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => resolve(img);
  img.onerror = reject;
  img.src = src;
});

// Draws the selected square region onto a 512x512 canvas and returns it as a JPEG blob.
const cropToBlob = async (src, area) => {
  const img = await loadImage(src);
  const canvas = document.createElement("canvas");
  canvas.width = OUTPUT_SIZE;
  canvas.height = OUTPUT_SIZE;
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#fff"; // flatten transparent PNGs instead of turning them black in JPEG
  ctx.fillRect(0, 0, OUTPUT_SIZE, OUTPUT_SIZE);
  ctx.drawImage(img, area.x, area.y, area.width, area.height, 0, 0, OUTPUT_SIZE, OUTPUT_SIZE);
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error("Crop failed"))), "image/jpeg", 0.92);
  });
};

// Modal with a circular mask: drag to reposition, slider/scroll to zoom. `image` is an object URL
// or data URL of the picked file; onConfirm receives the cropped square blob.
class AvatarCropDialog extends React.Component {
  state = { crop: { x: 0, y: 0 }, zoom: 1, area: null, busy: false };

  componentDidUpdate(prev){
    if(prev.image !== this.props.image){
      this.setState({ crop: { x: 0, y: 0 }, zoom: 1, area: null, busy: false });
    }
  }

  confirm = async () => {
    const { image, onConfirm } = this.props;
    if(!this.state.area){ return; }
    this.setState({ busy: true });
    try{
      const blob = await cropToBlob(image, this.state.area);
      await onConfirm(blob);
    }catch(err){
      console.error("avatar crop failed:", err);
      alert("Failed to crop image. Please try another one.");
    }
    this.setState({ busy: false });
  };

  render(){
    const { image, open, onClose } = this.props;
    const { crop, zoom, busy } = this.state;
    return (
      <Dialog open={!!open && !!image} onClose={busy ? undefined : onClose} maxWidth="xs" fullWidth>
        <DialogTitle>Adjust your avatar</DialogTitle>
        <DialogContent>
          <div style={{ position: "relative", width: "100%", height: 300, background: "#333" }}>
            <Cropper
              image={image}
              crop={crop}
              zoom={zoom}
              aspect={1}
              cropShape="round"
              showGrid={false}
              onCropChange={(c) => this.setState({ crop: c })}
              onZoomChange={(z) => this.setState({ zoom: z })}
              onCropComplete={(_, areaPixels) => this.setState({ area: areaPixels })}
            />
          </div>
          <Typography variant="caption" style={{ display: "block", marginTop: 12, color: "#4F4F4F" }}>Zoom</Typography>
          <Slider value={zoom} min={1} max={3} step={0.01} onChange={(e, v) => this.setState({ zoom: v })} />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={busy} style={{ textTransform: "none" }}>Cancel</Button>
          <Button onClick={this.confirm} disabled={busy || !this.state.area} style={{ textTransform: "none", fontWeight: "bold", background: "#FA841B", color: "#fff" }}>
            {busy ? "Uploading..." : "Use this photo"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default AvatarCropDialog;
